import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { find, includes, isEmpty, parseInt, size } from "lodash";

import { useAuth } from "../../AuthProvider";

import { getMemberProfileAction, getMemberTradeMode, getOtherDetailAction, getUpdatedProfile, updateCompanyStatus } from "../../actions/updateProfileAction";

import { Tab, Row, Col, Nav } from "react-bootstrap";
import { ToastContainer } from "react-toastify";

import SubHeader from "../../components/SubHeader";
import OtherDetails from "../../components/updateProfile/otherDetails";
import MemberServices from "../../components/updateProfile/MemberServices";
import CompanyInfo from "../../components/updateProfile/CompanyInfo";
import ContectInfo from "../../components/updateProfile/ContectInfo";
import Certificate from "../../components/updateProfile/Certificate";
import RefrralSection from "../../components/updateProfile/RefrralSection";


import TextAreaField from "../../components/TextAreaField";
import MediumPopup from "../../components/MediumPopup";
import { showErrorMessage, showSuccessMessage, istTODate, buildPath, getPrefix } from "../../utils/common";
import errorMessages from "../../constant/errorMessages";
import SmallPopup from "../../components/SmallPopup";
import { getSubscriptionPlanList } from "../../actions/subscriptionPlanAction";
import DropDown from "../../components/DropDown";
import { assignPlanToMember, manageContacts } from "../../actions/memberAction";
import ButtonAdminpanel from "../../components/ButtonAdminpanel";
import CheckBox from "../../components/CheckBox";
import Emitter from "../../utils/Emitter";
import InputField from '../../components/InputField';
import DatePickerField from '../../components/DatePickerField';
import RadioButtonField from "../../components/RadioButtonField";
import PromotionMediaInfo from "../../components/updateProfile/PromotionMediaInfo";
import { viewProfileAction } from '../../actions/viewProfileAction';
import { privateRoutePaths } from "@/routes/private.route.config";
import roles from "@/constant/roles.config";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  FontSize,
  Paragraph,
  List,
  Indent
} from "ckeditor5";
import LogisticPartnerCertificate from "@/components/updateProfile/LogisticPartnerCertificate";
import { publicRoutePaths } from "@/routes/public.routes.config";

function Updateprofile(props) {

  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { user, isSuperAdmin, isEndUser, isPreKYCUser, memberCompanyID, isDemoUser, trade_mode_type, isViewer, isOpUser, company_plan, isInqUser } = useAuth();
  const [companyStatus, setCompanyStatus] = useState(-1);
  const [reasonModalShow, setReasonModalShow] = useState(false);
  const [consentModal, setConsentModal] = useState(false);
  const [reason, setReason] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [disableProfile, setDisableProfile] = useState(false);
  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [planmodalShow, setPlanModalShow] = useState(false);
  const [planList, setPlanList] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({
    label: "Free",
    value: ""
  });
  const [assignedPlanId, setAssignedPlanId] = useState(0);

  const tradeModeRef = useRef(null);
  const initialRef = useRef(true);

  const scrollRef = useRef(null);

  const [isCheckedEnabled, setIsCheckedEnabled] = useState(false);
  const [consentBtnEnabled, setIsConsentBtnEnabled] = useState(false);
  const [isConsentChecked, setIsConsetChecked] = useState(false);

  const [errors0, setErrors0] = useState({});
  const [assignPlanData, setAssignPlanData] = useState([]);
  const [datePlan, setDatePlan] = useState(null);
  const [badgePlan, setBadgeType] = useState(null);
  const [isButtonDisabled, setisButtonDisabled] = useState(false);
  const [datePlan0, setDatePlan0] = useState(null);

  const [manageContactModalShow, setManageContactModalShow] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [contactDetail, setContactDetail] = useState("");
  const [company_contactDetail, setCompanyContactDetail] = useState("");
  const [errorContactDetail, setErrorContactDetail] = useState("");
  const [cpInfo, setCpInfo] = useState(null);

  const handleScroll = () => {
    const div = scrollRef.current;
    if (div) {
      const isBottom = div.scrollTop + div.clientHeight >= div.scrollHeight - 1;
      if (isBottom) {
        setIsCheckedEnabled(true);

        if (isConsentChecked) {
          setIsConsentBtnEnabled(true);
        } else {
          setIsConsentBtnEnabled(false);
        }
      }
      else {
        if (!isConsentChecked) {
          setIsCheckedEnabled(false);
          setIsConsentBtnEnabled(false);
        }

      }
    }

  };

  const handleConsentClick = () => {
    setIsConsetChecked(!isConsentChecked);
    setIsConsentBtnEnabled(!isConsentChecked);
  }

  const handleReasonChange = (e) => {
    setReason(e);
  }

  const handleCompanyStatusClick = async (status, reason = '', is_concerned = false) => {
    if (isSuperAdmin || isOpUser) {
      await props
        .updateCompanyStatus(id, status, reason)
        .then(async (response) => {
          const errObj = {};
          if (response.status == true) {
            setCompanyStatus(status);
            await props.getOtherDetailAction(id);
            await props.getMemberProfileAction(id);
            if (status === 1) {
              showSuccessMessage("Company has been approved");
            } else if (status === 4) {
              setReason("");
              setReasonModalShow(false);
              showSuccessMessage("Company has been Rejected");
              await props.getUpdatedProfile();
            } else if (status === 10) {
              setSmallModalShow(false);
              showSuccessMessage("Company has been Suspended");
            } else if (status === 2) {
              showSuccessMessage("Company has been set to InProgress");
            }
          }

          if (response.status == false) {
            if (response.message === "All validation error.") {

              if (!isEmpty(response.error.reason)) {
                errObj.reason_max_char = response.error.reason[0];
              }
            }
            setErrors(errObj);
          }

        })
        .catch((err) => {
          console.log("Error =", err);
          showErrorMessage("Something went wrong");
        });
    }
    if ((isEndUser || isPreKYCUser) && memberCompanyID > 0) {
      if (props.member_certificates.length === 0) {
        showErrorMessage("Please upload certificates");
      } else {

        if (status === 3) {
          setIsConsentBtnEnabled(false);
        }
        await props
          .updateCompanyStatus(memberCompanyID, status, reason, is_concerned)
          .then(async (response) => {
            if (response.status == true) {
              setCompanyStatus(status);
              Emitter.emit("UPDATE_COMPANY_PROFILE_STATUS", {});
              if (status == 3) {

                showSuccessMessage("Your profile has been sent to administrator for the approval");
                setConsentModal(false);
                setIsCheckedEnabled(false);
                setIsConsentBtnEnabled(false);

              }
            }
          })
          .catch((err) => {
            console.log("Error ========= ", err);
            showErrorMessage("Something went wrong");
          });
      }
    }
  };

  const openReasonModal = () => {
    setErrors({});
    setReasonModalShow(true);
  }

  const handleFocusOut = (e) => {
    let errObj = { ...errors };
    if (e.target.name === "reason") {
      if (e.target.value === '') {
        errObj.reason_max_char = errorMessages.FIELD_REQUIRED;
      }
      if (size(e.target.value) > 500) {
        errObj.reason_max_char = errorMessages.MAX_CHARACTERS_REACHED;
      } else {
        errObj.reason_max_char = "";
      }
    }
    setErrors(errObj);
  }

  const validReason = () => {
    let errObj = { ...errors };
    let errorFlag = 0;
    if (reason === '') {
      errorFlag = 1;
      errObj.reason_max_char = errorMessages.FIELD_REQUIRED;
    }
    if (!isEmpty(reason)) {
      if (size(reason) > 500) {
        errObj.reason_max_char = errorMessages.MAX_CHARACTERS_REACHED;
        errorFlag = 1;
      } else {
        errObj.reason_max_char = "";
        errorFlag = 0;
      }
    }
    setErrors(errObj);
    return errorFlag;
  }

  const handleAddReasonClick = () => {
    if (!validReason()) {
      handleCompanyStatusClick(4, reason)
    }
  }

  const handleSuspendClick = () => {
    setSmallModalShow(true);
  };

  const handleAssignPlan = () => {
    
    const otherDetail = cpInfo.memberdetail;
    if (!isEmpty(otherDetail) && (otherDetail !== null) && (otherDetail !== undefined) && (otherDetail !== "")) {
      // setAssignedPlanId(otherDetail[0].plan_id);
      setAssignedPlanId(otherDetail.plan_id);

      // const planOpt = find(planList, { value: otherDetail[0].plan_id });
      const planOpt = find(planList, { value: otherDetail.plan_id });

      if (planOpt) {
        setSelectedPlan(planOpt);
      }
    }

    if (cpInfo?.plan_to_date) {
      setDatePlan(new Date(cpInfo?.plan_to_date));
    } else {
      const currentDate = new Date();
      const nextYear = new Date(
        currentDate.getFullYear() + 1,
        currentDate.getMonth(),
        currentDate.getDate()
      );
      setDatePlan(nextYear);

    }

    if (cpInfo?.establish_date > 0 || !isEmpty(cpInfo?.establish_date)) {
      if (!isEmpty(cpInfo?.badge)) {
        setBadgeType(cpInfo?.badge);
      } else {
        if ((otherDetail && otherDetail?.plan_id === null) && isEmpty(cpInfo?.establish_date)) {
          setBadgeType(null);
        } else {
          if ((otherDetail && otherDetail?.plan_id !== null) && cpInfo?.badge) {
            setBadgeType(cpInfo?.badge);
          } else {
            const currentDate = new Date();
            const establishYear = parseInt(cpInfo?.establish_date);
            const monthsDifference = currentDate.getFullYear() - establishYear;
            if (monthsDifference <= 2) {
              setBadgeType("Basic");
            }
            else if (monthsDifference > 2 && monthsDifference <= 5) {
              setBadgeType("Plus");
            }
            else if (monthsDifference > 5 && monthsDifference <= 10) {
              setBadgeType("Pro");
            }
            else if (monthsDifference > 10) {
              setBadgeType("Elite");
            } else {
              setBadgeType(null);
            }
          }
        }

      }
    } else {
      if (cpInfo?.badge) {
        setBadgeType(cpInfo?.badge);
      } else {
        setBadgeType(null);
      }

    }
    if (otherDetail && otherDetail?.plan_id === null) {
      setSelectedPlan({ label: "Free", value: "" });
    }
    if (!isEmpty(cpInfo?.plan_from_date) || cpInfo?.plan_from_date) {
      setDatePlan0(new Date(cpInfo?.plan_from_date));
    } else {
      setDatePlan0(new Date());

    }

    setErrors0({});
    setisButtonDisabled(false);
    setAssignPlanData(cpInfo);
    setPlanModalShow(true);
  }

  // console.log('props.company_info ----> ', props.company_info.trade_mode_type);
  const getPlans = async (offset, limit, searchTxt = "") => {
    await props.getSubscriptionPlans(offset, limit, "created_at", "DESC", props.company_info.trade_mode_type, searchTxt).then((response) => {
      if (response.status === true) {
        let pList = response.data.map((val) => {
          return {
            label: val.name,
            value: val.id
          }
        });

        let defaultList = [{
          label: "Free",
          value: ""
        }];

        let newList = [...defaultList, ...pList];
        // console.log("newList ============= ", newList);
        /*pList.push({
          label: "Free",
          value: ""
        }); */
        setPlanList(newList);

        /*if (!isEmpty(props.getOtherDetail)) {
          if (props.getOtherDetail[0].plan_id === null || props.getOtherDetail[0].plan_id == "" || props.getOtherDetail[0].plan_id == 0) {
            setSelectedPlan(newList[0]);
          }
        } else if (isEmpty(props.getOtherDetail)) {
          setSelectedPlan(newList[0]);
        } */

      }
    }).catch((err) => {
      console.log("Error ==== ", err);
    })
  }

  const handlePlanChange = (val) => {
    setErrors0({});
    // console.log("handlePlanChange ========== ", val);
    if ((val.label !== 'Free')) {

      if (!isEmpty(assignPlanData.plan_to_date) || assignPlanData.plan_to_date) {
        setDatePlan(new Date(assignPlanData.plan_to_date));
      } else {
        const currentDate = new Date();
        const nextYear = new Date(
          currentDate.getFullYear() + 1,
          currentDate.getMonth(),
          currentDate.getDate()
        );
        setDatePlan(nextYear);
      }
      if (!isEmpty(assignPlanData.plan_from_date) || assignPlanData.plan_from_date) {
        setDatePlan0(new Date(assignPlanData.plan_from_date));
      } else {
        setDatePlan0(new Date());
      }

      if (assignPlanData.establish_date > 0 || !isEmpty(assignPlanData.establish_date)) {
        if (!isEmpty(assignPlanData.badge)) {
          setBadgeType(assignPlanData.badge);
        } else {
          const currentDate = new Date();
          const establishYear = parseInt(assignPlanData.establish_date);
          const monthsDifference = currentDate.getFullYear() - establishYear;
          if (monthsDifference <= 2) {
            setBadgeType("Basic");
          }
          else if (monthsDifference > 2 && monthsDifference <= 5) {
            setBadgeType("Plus");
          }
          else if (monthsDifference > 5 && monthsDifference <= 10) {
            setBadgeType("Pro");
          }
          else if (monthsDifference > 10) {
            setBadgeType("Elite");
          } else {
            setBadgeType(null);
          }
        }

      } else {
        if (assignPlanData.badge) {
          setBadgeType(assignPlanData.badge);
        } else {
          setBadgeType(null);
        }
      }


    } else {

      setDatePlan(null);
      setDatePlan0(null);
      setBadgeType(null);
    }
    setSelectedPlan(val);
    setAssignedPlanId(val.value);
  }

  /*const handlePlanInputChange = (val) => {
    console.log("handlePlanInputChange ========= ", val);
    if (size(val) > 3) {
      getPlans(0, 20, val);
    } else if (size(val) === 0) {
      getPlans(0, 20, "");
    }
  } */

  const validation0 = async () => {
    setErrors0({});
    let er = { ...errors };
    let flag = 0;
    if (selectedPlan?.label === 'Free') {
      if (isEmpty(assignPlanData.establish_date)) {
        flag = 1;
        er.establish_year = errorMessages.FIELD_REQUIRED;

      }
      setErrors0(er);
      if (flag === 1) {
        return false;
      } else {
        return true;
      }

    }
    if (!datePlan) {
      flag = 1;
      er.datePlan = errorMessages.FIELD_REQUIRED;
    } else {
      er.datePlan = "";
    }


    if (!datePlan0) {
      flag = 1;
      er.datePlan0 = errorMessages.FIELD_REQUIRED;
    } else {
      er.datePlan0 = "";
    }


    if (!badgePlan) {
      flag = 1;
      er.badgePlan = errorMessages.FIELD_REQUIRED;
    } else {
      er.badgePlan = "";
    }


    if (isEmpty(assignPlanData.establish_date)) {
      flag = 1;
      er.establish_year = errorMessages.FIELD_REQUIRED;
    } else {
      er.establish_year = "";
    }


    setErrors(er);
    if (flag === 1) {
      return false;
    } else {
      return true;
    }

  }

  const AssignPlanAndApprove = async (e) => {

    e.preventDefault();
    setErrors0({});
    setisButtonDisabled(false);
    const isValid = await validation0();
    if (isValid) {
      let fromDate = null;
      let toDate = null;

      if (datePlan0) {
        fromDate = istTODate(datePlan0);
      }
      if (datePlan) {
        toDate = istTODate(datePlan);
      }
      const data = {
        plan_id: selectedPlan.value,
        member_id: id,
        fromDate: fromDate,
        toDate: toDate,
        badge: badgePlan,
        establish_year: assignPlanData.establish_date
      }
      await props.assignPlanToMember(data).then((response) => {
        if (response.status === true) {
          setisButtonDisabled(true);
          showSuccessMessage(response.message);
          setPlanModalShow(false);
          handleCompanyStatusClick(1);


        } else if (response.status === false) {
          setisButtonDisabled(false);
          if (response.message === 'All validation error.') {
            let errObj = {};
            if (response.error) {
              if (response.error.toDate) {
                errObj.datePlan = response.error.toDate[0];
              }
              if (response.error.badge) {
                errObj.badgePlan = response.error.badge[0];
              }
              if (response.error.fromDate) {
                errObj.datePlan0 = response.error.fromDate[0];
              }
              if (response.error.establish_year) {
                errObj.establish_year = response.error.establish_year[0];
              }

            }
            setisButtonDisabled(false);
            setErrors0(errObj);
          } else {
            setisButtonDisabled(false);
            showErrorMessage("Something went wrong!");
          }
        }
      }).catch((err) => {
        setisButtonDisabled(false);
        console.log("Error ==== ", err);
        showErrorMessage("Something went wrong!");
      });
    }
  }

  useEffect(() => {
    if (!isEmpty(props.getOtherDetail) && id > 0) {

      const planOpt = find(planList, { value: assignedPlanId });

      if (planOpt) {
        setSelectedPlan(planOpt);
      }
    }
  }, [planList]);



  useEffect(() => {

    if (!isEmpty(props.company_info)) {
      let c_status = props.company_info.status;
      setCompanyStatus(c_status);

      if (parseInt(c_status) >= 0) {
        if ((isEndUser || isPreKYCUser) && parseInt(c_status) === 3) { // Sent For Approval / In Review
          setDisableProfile(true);
          setIsDisable(false);
        } else if (parseInt(c_status) === 1) { // Approved/Active Company 
          setDisableProfile(false);
          setIsDisable(true);
        } else {
          setDisableProfile(false);
          setIsDisable(false);
        }
      }

    }
    if (isSuperAdmin || isOpUser) {
      getPlans(0, 20, "");
    }
  }, [props.company_info.reason, props.company_info.status, props.company_info]);

  useEffect(() => {
    // console.log('setCompanyStatus -1 use effect');
    tradeModeRef.current = null;
    setCompanyStatus(-1);
  }, []);


  // const handleConsentModal = () => {
  //   console.log("handleConsentModal proop",cpInfo);
  //   if ((isEndUser || isPreKYCUser) && memberCompanyID > 0) {
  //     if (props.member_certificates.length < 2 && props.company_info.establish_date === null) {
  //       showErrorMessage("Uploading certificates and selecting the establish year are mandatory.");
  //     } else if (props.member_certificates.length < 2 && props.company_info.establish_date !== null) {
  //       showErrorMessage("Please upload certificates.");
  //     } else if (props.company_info.establish_date === null) {
  //       showErrorMessage("The establish year is mandatory.");
  //     } else {
  //       setConsentModal(true);
  //       setIsCheckedEnabled(false);
  //       setIsConsentBtnEnabled(false);
  //       setIsConsetChecked(false);
  //     }
  //   }

  // }
  const handleConsentModal = () => {
    props.viewCompany(id).then((response) => {
      if (response.status) {
        if (!isEmpty(response.data)) {
          if ((isEndUser || isPreKYCUser) && memberCompanyID > 0) {
            const companyData = response.data[0];

            const hasCertificates = companyData.member_certificates?.length >= 2;
            const hasEstablishDate = companyData.establish_date !== null;
            const hasReferenceContacts = companyData.member_reference_contacts?.length >= 2;
            const trade_mode_type = companyData.trade_mode_type;
            // const hasServices = companyData.member_services?.length > 0;

            if (trade_mode_type === "LOG_PTR") {
              if (!hasCertificates && !hasEstablishDate && !hasReferenceContacts) {
                showErrorMessage("Uploading certificates, reference contacts, and selecting the establish year are mandatory.");
              } else if (hasCertificates && !hasEstablishDate && !hasReferenceContacts) {
                showErrorMessage("Reference contacts and establish year are mandatory.");
              } else if (!hasCertificates && hasEstablishDate && !hasReferenceContacts) {
                showErrorMessage("Uploading certificates and reference contacts are mandatory.");
              } else if (!hasCertificates && !hasEstablishDate && hasReferenceContacts) {
                showErrorMessage("Uploading certificates and establish year are mandatory.");
              }
              else if (!hasCertificates) {
                showErrorMessage("Please upload certificates.");
              }
              else if (!hasEstablishDate) {
                showErrorMessage("The establish year is mandatory.");
              }
              else if (!hasReferenceContacts) {
                showErrorMessage("At least 2 reference contacts are mandatory.");
              } else {
                setConsentModal(true);
                setIsCheckedEnabled(false);
                setIsConsentBtnEnabled(false);
                setIsConsetChecked(false);
              }
            } else if (trade_mode_type === "SUPPLIER" || trade_mode_type === "BUYER") {
              const missingFields = [];

              if (!hasCertificates) missingFields.push("certificates");
              if (!hasEstablishDate) missingFields.push("establish year");
              //if (!hasReferenceContacts) missingFields.push("reference contacts");

              // if (trade_mode_type === "SUPPLIER") {
              //   if (!hasServices) missingFields.push("services");
              // }


              if (missingFields.length > 0) {
                const message = `${missingFields.join(", ")} ${missingFields.length > 1 ? "are" : "is"} mandatory.`;
                showErrorMessage(message);
              } else {
                setConsentModal(true);
                setIsCheckedEnabled(false);
                setIsConsentBtnEnabled(false);
                setIsConsetChecked(false);
              }
            }
          }
        } else {
          showErrorMessage("Something went wrong");
        }
      } else {
        showErrorMessage("Something went wrong");
      }
    }).catch((err) => {
      console.log("Error ============ ", err);
      showErrorMessage("An error occurred while fetching company data.");
    });
  };

  const disabledDate = (date) => {
    const today = new Date();
    return date < today;
  };


  const handleBadgeTypeChange = (e, type) => {
    setBadgeType(type);
  }

  const handleDateChange = (date) => {
    setDatePlan(date)
  }

  const handleBlur = (value) => {
    if (!value) {
      setErrors0(prev => ({
        ...prev,
        datePlan: errorMessages.FIELD_REQUIRED,
      }));

    } else {
      setErrors0(prev => ({
        ...prev,
        datePlan: "",
      }));

    }
  };

  const handleBlur0 = (value) => {
    if (!value) {
      setErrors0(prev => ({
        ...prev,
        datePlan0: errorMessages.FIELD_REQUIRED,
      }));

    } else {
      setErrors0(prev => ({
        ...prev,
        datePlan0: "",
      }));

    }
  };

  const handleManageContactModal = (id, contact_detail) => {
    console.log("contact_detail =========== ", contact_detail);
    setSelectedMemberId(id);
    setErrorContactDetail("");
    if (contact_detail) {
      setContactDetail(contact_detail);
    }
    setManageContactModalShow(true);
  }

  const validContactDetail = () => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = contactDetail;

    const trimmedText = tempDiv.textContent.trim();

    if (isEmpty(trimmedText)) {
      setErrorContactDetail(errorMessages.FIELD_REQUIRED)
      return false;
    }
    return true;
  }

  const AddContacts = async () => {

    if (await validContactDetail()) {
      let reqObj = {
        contact_detail: contactDetail
      }
      await props.manageContacts(reqObj, selectedMemberId).then((response) => {
        if (response.status === true) {
          showSuccessMessage(response.message);
          setManageContactModalShow(false);
          setTimeout(() => {
            fetchCompanyProfile(id);
          }, 2000);
        }
      }).catch((err) => {
        console.log("Error ============= ", err);
      });
    }
  }

  useEffect(() => {
    if (datePlan0 === null || datePlan0 === "" || datePlan === null || datePlan === "") {
      setisButtonDisabled(true);
    } else {
      setisButtonDisabled(false);
    }

    if (selectedPlan?.label === 'Free') {
      setisButtonDisabled(false);
    }

  }, [datePlan0, datePlan, selectedPlan]);

  // const fetchCompanyProfile = async (id) => {
  const fetchCompanyProfile = (id) => {
    // await props.viewCompany(id).then(async (response) => {
    props.viewCompany(id).then((response) => {
      if (response.status === false) {
        tradeModeRef.current = "BUYER_SUPPLIER";
      }
      if (response.status) {
        if (!isEmpty(response.data)) {
          if (response.data[0].additional_contacts) {
            setContactDetail(response.data[0].additional_contacts.contact_detail);
            setCompanyContactDetail(response.data[0].additional_contacts.contact_detail);
          }
          setCpInfo(response.data[0]);
          const companyInformation = { trade_mode_type: response.data[0].trade_mode_type }
          const savedUser = localStorage.getItem("user");
          let userInfo = savedUser ? JSON.parse(savedUser) : null;
          if (searchParams.get("lead") === null && searchParams.get("logistic") === null && searchParams.get("paid") === null && searchParams.get("pending") === null) {

            if (companyInformation.trade_mode_type !== "LOG_PTR") {
              tradeModeRef.current = "BUYER_SUPPLIER";
              Emitter.emit("TRADE_MODE_TYPE", "BUYER_SUPPLIER");

              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "END_USER") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              }
              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "PRE_KYC") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              }
              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "DEMO") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              }

            } else {
              tradeModeRef.current = "LOG_PTR";
              Emitter.emit("TRADE_MODE_TYPE", "LOG_PTR");
              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "END_USER") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              } else if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "PRE_KYC") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              } else if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "PRE_KYC") && userInfo.member_id != id) {
                tradeModeRef.current = "BUYER_SUPPLIER";
                Emitter.emit("TRADE_MODE_TYPE", "BUYER_SUPPLIER");
              } else if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "DEMO") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              }

            }
          } else {
            let l = searchParams.get("lead") || searchParams.get("logistic") || searchParams.get("paid") || searchParams.get("pending");
            let l1 = atob(l);
            if (l1 === "WEB") {
              tradeModeRef.current = "REG_LEAD";
              Emitter.emit("TRADE_MODE_TYPE", "REG_LEAD");
            }
            if (l1 === "Paid") {
              tradeModeRef.current = "PAID_LEAD";
              Emitter.emit("TRADE_MODE_TYPE", "PAID_LEAD");
            }
            if (l1 === "ProfileReq") {
              tradeModeRef.current = "PROFILE";
              Emitter.emit("TRADE_MODE_TYPE", "PROFILE");
            }
            if (l1 === "LOGISTIC") {
              tradeModeRef.current = "LOG_PTR";
              Emitter.emit("TRADE_MODE_TYPE", "LOG_PTR");
            }



          }
        }
      }
    }).catch((err) => {
      console.log("Error ============ ", err);
    });
  }
  useEffect(() => {
    fetchCompanyProfile(id);
  }, [id]);

  // const getPrefix = () => {
  //   if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
  //   if (user && isDemoUser) return roles.DEMO.prefix;
  //   if (user && isEndUser) return roles.END_USER.prefix;
  //   if (user && isViewer) return roles.VIEWER.prefix;
  //   return roles.SUPER_ADMIN.prefix;
  // };

  const styleError = {
    display: "block",
  };

  console.log("cpInfo.trade_mode_type ----",cpInfo);

  return (
    <div className="container-fluid">

      {
        (isSuperAdmin || isViewer || isOpUser || isInqUser) && tradeModeRef.current === "BUYER_SUPPLIER" && <SubHeader layer1="Supplier Directory" layer2="Profile" layer3="Update" pageName="Company Update Profile" subTitle=""
          clickable={{
            layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_MEMBERS.path}`,
            layer2: "",
            layer3: ""
          }}
        />
      }
      {
        (isSuperAdmin || isViewer || isOpUser || isInqUser) && tradeModeRef.current === "LOG_PTR" && <SubHeader layer1="Logistics Directory" layer2="Profile" layer3="Update" pageName="Company Update Profile" subTitle=""
          clickable={{
            layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`,
            layer2: "",
            layer3: ""
          }}
        />
      }
      {
        (isSuperAdmin || isViewer || isOpUser || isInqUser) && tradeModeRef.current === "REG_LEAD" && <SubHeader layer1="Lead Management" layer2="Profile" layer3="Update" pageName="Company Update Profile" subTitle=""
          clickable={{
            layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_LEADS.path}`,
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        (isSuperAdmin || isViewer || isOpUser || isInqUser) && tradeModeRef.current === "PROFILE" && <SubHeader layer1="Profile Requests" layer2="Profile" layer3="Update" pageName="Company Update Profile" subTitle=""
          clickable={{
            layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_PENDING_MEMBERS.path}`,
            layer2: "",
            layer3: ""
          }}
        />
      }

      {(isSuperAdmin || isOpUser || isInqUser) && tradeModeRef.current === "PAID_LEAD" && <SubHeader layer1="Paid Members" layer2="Profile" layer3="Update" pageName="Company Update Profile" subTitle=""
        clickable={{
          layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_PAID_MEMBERS.path}`,
          layer2: "",
          layer3: ""
        }}
      />
      }
      {
        (isEndUser) && <SubHeader layer1="Profile" layer2="Update" layer3="" pageName="Company Update Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }
      {
        (isPreKYCUser) && <SubHeader layer1="Profile" layer2="Update" layer3="" pageName="Company Update Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }
      {
        (isDemoUser) && <SubHeader layer1="Profile" layer2="Update" layer3="" pageName="Company Update Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }


      {/* <div className="my-2" style={{ display: 'none' }}> */}
      <div >

      </div>

      <Tab.Container id="left-tabs-example" defaultActiveKey="Compney Info">
        <Row>

          <Col sm={12} className="tab-menu">

            <div className="tab-menu-child custom-pills-padding">

              <Nav variant="pills" >
                <Nav.Item>
                  <Nav.Link eventKey="Compney Info" className="d-flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      height="22px"
                    >
                      <path
                        fillRule="evenodd"
                        fill="rgb(11, 68, 113)"
                        d="M19.631,22.000 L0.369,22.000 C0.165,22.000 -0.001,21.834 -0.001,21.629 C-0.001,21.424 0.165,21.258 0.369,21.258 L0.987,21.258 L0.987,7.292 C0.987,7.087 1.152,6.921 1.357,6.921 L4.444,6.921 L4.444,3.832 C4.444,3.627 4.609,3.461 4.814,3.461 L5.926,3.461 L5.926,1.854 C5.926,1.649 6.091,1.483 6.296,1.483 L7.901,1.483 L7.901,0.371 C7.901,0.166 8.067,-0.000 8.271,-0.000 C8.476,-0.000 8.642,0.166 8.642,0.371 L8.642,1.483 L10.247,1.483 C10.452,1.483 10.617,1.649 10.617,1.854 L10.617,3.461 L11.358,3.461 L11.358,1.854 C11.358,1.649 11.524,1.483 11.729,1.483 L18.643,1.483 C18.848,1.483 19.013,1.649 19.013,1.854 L19.013,21.258 L19.631,21.258 C19.835,21.258 20.001,21.424 20.001,21.629 C20.001,21.834 19.835,22.000 19.631,22.000 ZM4.197,21.258 L4.444,21.258 L4.444,20.641 C4.444,20.435 4.609,20.270 4.814,20.270 C5.019,20.270 5.185,20.435 5.185,20.641 L5.185,21.258 L5.432,21.258 L5.432,20.023 L4.197,20.023 L4.197,21.258 ZM1.728,7.663 L1.728,21.258 L3.456,21.258 L3.456,19.652 C3.456,19.447 3.622,19.281 3.827,19.281 L5.802,19.281 C6.007,19.281 6.172,19.447 6.172,19.652 L6.172,21.258 L7.901,21.258 L7.901,11.742 L7.901,7.663 L1.728,7.663 ZM9.877,2.225 L6.666,2.225 L6.666,3.461 L9.877,3.461 L9.877,2.225 ZM11.358,4.202 L5.185,4.202 L5.185,6.921 L8.271,6.921 C8.476,6.921 8.642,7.087 8.642,7.292 L8.642,7.416 L9.753,7.416 C9.958,7.416 10.124,7.582 10.124,7.787 C10.124,7.992 9.958,8.158 9.753,8.158 L8.642,8.158 L8.642,9.393 L9.753,9.393 C9.958,9.393 10.124,9.559 10.124,9.764 C10.124,9.969 9.958,10.135 9.753,10.135 L8.642,10.135 L8.642,11.371 L11.358,11.371 L11.358,4.202 ZM8.642,12.113 L8.642,21.258 L14.815,21.258 L14.815,12.113 L8.642,12.113 ZM18.272,2.225 L12.099,2.225 L12.099,11.371 L13.333,11.371 L13.333,11.247 C13.333,11.042 13.499,10.876 13.704,10.876 C13.909,10.876 14.074,11.042 14.074,11.247 L14.074,11.371 L14.815,11.371 L14.815,11.247 C14.815,11.042 14.981,10.876 15.186,10.876 C15.390,10.876 15.556,11.042 15.556,11.247 L15.556,21.258 L18.272,21.258 L18.272,2.225 ZM16.667,3.460 C16.872,3.460 17.038,3.626 17.038,3.831 L17.038,4.326 C17.038,4.531 16.872,4.696 16.667,4.696 C16.462,4.696 16.297,4.531 16.297,4.326 L16.297,3.831 C16.297,3.626 16.462,3.460 16.667,3.460 ZM16.667,5.932 C16.872,5.932 17.038,6.098 17.038,6.303 L17.038,6.798 C17.038,7.003 16.872,7.168 16.667,7.168 C16.462,7.168 16.297,7.003 16.297,6.798 L16.297,6.303 C16.297,6.098 16.462,5.932 16.667,5.932 ZM16.667,8.404 C16.872,8.404 17.038,8.570 17.038,8.775 L17.038,9.270 C17.038,9.475 16.872,9.641 16.667,9.641 C16.462,9.641 16.297,9.475 16.297,9.270 L16.297,8.775 C16.297,8.570 16.462,8.404 16.667,8.404 ZM16.667,10.876 C16.872,10.876 17.038,11.042 17.038,11.247 L17.038,11.742 C17.038,11.947 16.872,12.113 16.667,12.113 C16.462,12.113 16.297,11.947 16.297,11.742 L16.297,11.247 C16.297,11.042 16.462,10.876 16.667,10.876 ZM16.667,13.348 C16.872,13.348 17.038,13.514 17.038,13.719 L17.038,14.214 C17.038,14.418 16.872,14.584 16.667,14.584 C16.462,14.584 16.297,14.418 16.297,14.214 L16.297,13.719 C16.297,13.514 16.462,13.348 16.667,13.348 ZM16.667,15.820 C16.872,15.820 17.038,15.986 17.038,16.191 L17.038,16.685 C17.038,16.890 16.872,17.056 16.667,17.056 C16.462,17.056 16.297,16.890 16.297,16.685 L16.297,16.191 C16.297,15.986 16.462,15.820 16.667,15.820 ZM16.667,18.292 C16.872,18.292 17.038,18.458 17.038,18.663 L17.038,19.157 C17.038,19.362 16.872,19.528 16.667,19.528 C16.462,19.528 16.297,19.362 16.297,19.157 L16.297,18.663 C16.297,18.458 16.462,18.292 16.667,18.292 ZM15.186,9.641 C14.981,9.641 14.815,9.475 14.815,9.270 L14.815,8.775 C14.815,8.570 14.981,8.404 15.186,8.404 C15.390,8.404 15.556,8.570 15.556,8.775 L15.556,9.270 C15.556,9.475 15.390,9.641 15.186,9.641 ZM15.186,7.168 C14.981,7.168 14.815,7.003 14.815,6.798 L14.815,6.303 C14.815,6.098 14.981,5.932 15.186,5.932 C15.390,5.932 15.556,6.098 15.556,6.303 L15.556,6.798 C15.556,7.003 15.390,7.168 15.186,7.168 ZM15.186,4.696 C14.981,4.696 14.815,4.531 14.815,4.326 L14.815,3.831 C14.815,3.626 14.981,3.460 15.186,3.460 C15.390,3.460 15.556,3.626 15.556,3.831 L15.556,4.326 C15.556,4.531 15.390,4.696 15.186,4.696 ZM13.704,9.641 C13.499,9.641 13.333,9.475 13.333,9.270 L13.333,8.775 C13.333,8.570 13.499,8.404 13.704,8.404 C13.909,8.404 14.074,8.570 14.074,8.775 L14.074,9.270 C14.074,9.475 13.909,9.641 13.704,9.641 ZM13.704,7.168 C13.499,7.168 13.333,7.003 13.333,6.798 L13.333,6.303 C13.333,6.098 13.499,5.932 13.704,5.932 C13.909,5.932 14.074,6.098 14.074,6.303 L14.074,6.798 C14.074,7.003 13.909,7.168 13.704,7.168 ZM13.704,4.696 C13.499,4.696 13.333,4.531 13.333,4.326 L13.333,3.831 C13.333,3.626 13.499,3.460 13.704,3.460 C13.909,3.460 14.074,3.626 14.074,3.831 L14.074,4.326 C14.074,4.531 13.909,4.696 13.704,4.696 ZM13.210,20.517 C13.006,20.517 12.840,20.351 12.840,20.146 L12.840,13.224 C12.840,13.019 13.006,12.854 13.210,12.854 C13.415,12.854 13.581,13.019 13.581,13.224 L13.581,20.146 C13.581,20.351 13.415,20.517 13.210,20.517 ZM11.729,20.517 C11.524,20.517 11.358,20.351 11.358,20.146 L11.358,13.224 C11.358,13.019 11.524,12.854 11.729,12.854 C11.933,12.854 12.099,13.019 12.099,13.224 L12.099,20.146 C12.099,20.351 11.933,20.517 11.729,20.517 ZM10.247,20.517 C10.042,20.517 9.876,20.351 9.876,20.146 L9.876,13.224 C9.876,13.019 10.042,12.854 10.247,12.854 C10.451,12.854 10.617,13.019 10.617,13.224 L10.617,20.146 C10.617,20.351 10.451,20.517 10.247,20.517 ZM9.753,6.180 L6.790,6.180 C6.585,6.180 6.420,6.014 6.420,5.809 C6.420,5.604 6.585,5.438 6.790,5.438 L9.753,5.438 C9.958,5.438 10.124,5.604 10.124,5.809 C10.124,6.014 9.958,6.180 9.753,6.180 ZM6.296,18.045 C6.091,18.045 5.926,17.879 5.926,17.674 L5.926,17.179 C5.926,16.974 6.091,16.808 6.296,16.808 C6.501,16.808 6.667,16.974 6.667,17.179 L6.667,17.674 C6.667,17.879 6.501,18.045 6.296,18.045 ZM6.296,15.573 C6.091,15.573 5.926,15.407 5.926,15.202 L5.926,14.708 C5.926,14.503 6.091,14.337 6.296,14.337 C6.501,14.337 6.667,14.503 6.667,14.708 L6.667,15.202 C6.667,15.407 6.501,15.573 6.296,15.573 ZM6.296,13.101 C6.091,13.101 5.926,12.935 5.926,12.730 L5.926,12.236 C5.926,12.031 6.091,11.865 6.296,11.865 C6.501,11.865 6.667,12.031 6.667,12.236 L6.667,12.730 C6.667,12.935 6.501,13.101 6.296,13.101 ZM6.296,10.629 C6.091,10.629 5.926,10.463 5.926,10.258 L5.926,9.764 C5.926,9.559 6.091,9.393 6.296,9.393 C6.501,9.393 6.667,9.559 6.667,9.764 L6.667,10.258 C6.667,10.463 6.501,10.629 6.296,10.629 ZM4.814,18.045 C4.610,18.045 4.444,17.879 4.444,17.674 L4.444,17.179 C4.444,16.974 4.610,16.808 4.814,16.808 C5.019,16.808 5.185,16.974 5.185,17.179 L5.185,17.674 C5.185,17.879 5.019,18.045 4.814,18.045 ZM4.814,15.573 C4.610,15.573 4.444,15.407 4.444,15.202 L4.444,14.708 C4.444,14.503 4.610,14.337 4.814,14.337 C5.019,14.337 5.185,14.503 5.185,14.708 L5.185,15.202 C5.185,15.407 5.019,15.573 4.814,15.573 ZM4.814,13.101 C4.610,13.101 4.444,12.935 4.444,12.730 L4.444,12.236 C4.444,12.031 4.610,11.865 4.814,11.865 C5.019,11.865 5.185,12.031 5.185,12.236 L5.185,12.730 C5.185,12.935 5.019,13.101 4.814,13.101 ZM4.814,10.629 C4.610,10.629 4.444,10.463 4.444,10.258 L4.444,9.764 C4.444,9.559 4.610,9.393 4.814,9.393 C5.019,9.393 5.185,9.559 5.185,9.764 L5.185,10.258 C5.185,10.463 5.019,10.629 4.814,10.629 ZM3.333,18.045 C3.128,18.045 2.962,17.879 2.962,17.674 L2.962,17.179 C2.962,16.974 3.128,16.808 3.333,16.808 C3.537,16.808 3.703,16.974 3.703,17.179 L3.703,17.674 C3.703,17.879 3.537,18.045 3.333,18.045 ZM3.333,15.573 C3.128,15.573 2.962,15.407 2.962,15.202 L2.962,14.708 C2.962,14.503 3.128,14.337 3.333,14.337 C3.537,14.337 3.703,14.503 3.703,14.708 L3.703,15.202 C3.703,15.407 3.537,15.573 3.333,15.573 ZM3.333,13.101 C3.128,13.101 2.962,12.935 2.962,12.730 L2.962,12.236 C2.962,12.031 3.128,11.865 3.333,11.865 C3.537,11.865 3.703,12.031 3.703,12.236 L3.703,12.730 C3.703,12.935 3.537,13.101 3.333,13.101 ZM3.333,10.629 C3.128,10.629 2.962,10.463 2.962,10.258 L2.962,9.764 C2.962,9.559 3.128,9.393 3.333,9.393 C3.537,9.393 3.703,9.559 3.703,9.764 L3.703,10.258 C3.703,10.463 3.537,10.629 3.333,10.629 Z"
                      />
                    </svg>

                    <p className="ps-1 profile-tab">Company Info</p>
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Contact Info" className="d-flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22px"
                      height="22px"
                    >
                      <path
                        fillRule="evenodd"
                        fill="rgb(11, 68, 113)"
                        d="M15.764,4.548 C16.985,4.548 17.983,3.542 17.983,2.299 C17.983,1.056 16.990,0.050 15.764,0.050 C14.537,0.050 13.545,1.056 13.545,2.299 C13.545,3.542 14.537,4.548 15.764,4.548 ZM15.764,1.425 C16.242,1.425 16.627,1.820 16.627,2.299 C16.627,2.778 16.237,3.173 15.764,3.173 C15.291,3.173 14.901,2.778 14.901,2.299 C14.901,1.820 15.291,1.425 15.764,1.425 ZM12.266,11.189 L19.262,11.189 C19.636,11.189 19.937,10.884 19.937,10.505 L19.937,8.056 C19.937,6.344 18.565,4.953 16.876,4.953 L14.646,4.953 C12.957,4.953 11.585,6.344 11.585,8.056 L11.585,10.505 C11.585,10.884 11.887,11.189 12.261,11.189 L12.266,11.189 ZM12.942,8.056 C12.942,7.102 13.706,6.328 14.646,6.328 L16.876,6.328 C17.817,6.328 18.581,7.102 18.581,8.056 L18.581,9.820 L12.942,9.820 L12.942,8.056 ZM21.897,17.357 C21.684,16.477 20.639,15.514 19.797,14.860 C19.033,14.265 17.864,13.502 17.084,13.296 C16.517,13.149 16.200,13.333 16.034,13.517 C16.034,13.517 14.730,14.955 14.272,15.424 C14.199,15.498 13.976,15.498 13.700,15.424 C12.703,15.155 11.154,14.044 9.652,12.522 C8.150,10.1000 7.053,9.430 6.788,8.419 C6.715,8.140 6.715,7.913 6.788,7.840 C7.245,7.376 8.669,6.054 8.669,6.054 C8.851,5.886 9.033,5.564 8.888,4.990 C8.685,4.200 7.931,3.015 7.344,2.241 C6.700,1.388 5.749,0.329 4.881,0.113 C4.413,-0.003 3.976,0.124 3.675,0.466 L1.284,3.173 C0.031,4.590 -0.021,6.734 1.123,9.378 C2.074,11.569 3.805,14.002 6.003,16.225 C8.202,18.453 10.598,20.206 12.760,21.170 C14.002,21.723 15.135,22.002 16.133,22.002 C17.224,22.002 18.149,21.671 18.882,21.007 L21.554,18.584 C21.886,18.284 22.011,17.836 21.902,17.362 L21.897,17.357 ZM17.973,19.980 C16.746,21.097 14.750,20.559 13.300,19.912 C11.289,19.016 9.038,17.362 6.954,15.256 C4.875,13.149 3.243,10.863 2.360,8.825 C1.721,7.350 1.190,5.333 2.292,4.090 L4.615,1.461 C4.860,1.556 5.483,2.020 6.315,3.131 C7.027,4.084 7.427,4.874 7.552,5.233 C7.006,5.738 6.294,6.402 5.837,6.865 C5.530,7.176 5.218,7.755 5.483,8.772 C5.811,10.020 7.011,11.785 8.695,13.491 C10.379,15.198 12.120,16.414 13.352,16.746 C14.350,17.015 14.927,16.704 15.234,16.388 C15.691,15.924 16.346,15.203 16.845,14.650 C17.198,14.771 17.978,15.177 18.919,15.903 C20.020,16.751 20.478,17.378 20.566,17.626 L17.973,19.980 Z"
                      />
                    </svg>
                    <p className="ps-1 profile-tab">Staff Info</p>
                  </Nav.Link>
                </Nav.Item>

                {
                cpInfo && cpInfo.trade_mode_type == "LOG_PTR" &&
                  <Nav.Item>
                    <Nav.Link eventKey="Services" className="d-flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          fill="rgb(11, 68, 113)"
                          d="M22.808,11.457 C21.396,14.022 19.606,16.131 17.506,17.712 C16.955,18.134 16.301,18.345 15.578,18.345 L10.241,18.345 C10.000,18.345 9.794,18.380 9.587,18.451 C9.553,18.521 9.518,18.521 9.484,18.521 C9.312,18.521 9.174,18.415 9.139,18.240 C9.071,18.064 9.208,17.853 9.380,17.783 C9.656,17.712 9.931,17.677 10.241,17.677 L15.647,17.677 C16.198,17.677 16.714,17.502 17.127,17.185 C19.158,15.674 20.880,13.636 22.257,11.141 C22.326,11.035 22.326,10.895 22.291,10.789 C22.257,10.684 22.188,10.578 22.050,10.508 C21.809,10.403 21.568,10.332 21.293,10.332 C20.708,10.332 20.157,10.649 19.847,11.141 C19.778,11.281 19.331,12.125 19.055,12.406 C18.648,12.792 17.580,13.326 16.988,13.589 C17.016,13.698 17.058,13.805 17.058,13.917 C17.058,14.795 16.404,15.463 15.578,15.463 L11.067,15.463 C10.861,15.463 10.723,15.287 10.723,15.112 C10.723,14.936 10.895,14.760 11.067,14.760 L15.578,14.760 C15.991,14.760 16.335,14.409 16.335,13.987 C16.335,13.776 16.266,13.601 16.094,13.460 C15.956,13.319 15.750,13.249 15.543,13.249 L13.168,13.249 C12.513,13.249 11.859,13.038 11.308,12.617 C10.964,12.230 10.482,12.054 9.966,12.054 L8.244,12.054 C7.659,12.054 7.074,12.265 6.660,12.687 L5.352,13.952 C5.214,14.093 4.973,14.093 4.836,13.952 C4.698,13.812 4.698,13.565 4.836,13.425 L6.144,12.160 C6.695,11.633 7.452,11.316 8.210,11.316 L9.931,11.316 C10.585,11.316 11.240,11.527 11.790,11.949 C12.204,12.265 12.686,12.441 13.202,12.441 L15.578,12.441 C15.956,12.441 16.370,12.617 16.611,12.863 C16.627,12.880 16.634,12.904 16.650,12.922 C17.447,12.551 18.289,12.098 18.539,11.843 C18.676,11.738 18.986,11.176 19.193,10.754 C19.640,10.016 20.432,9.594 21.259,9.594 C21.637,9.594 21.982,9.665 22.326,9.840 C22.601,9.981 22.842,10.227 22.911,10.543 C23.015,10.859 22.980,11.176 22.808,11.457 ZM13.133,3.971 C15.130,3.971 16.748,5.588 16.748,7.591 C16.748,9.594 15.130,11.211 13.133,11.211 C11.136,11.211 9.518,9.594 9.518,7.591 C9.518,5.588 11.136,3.971 13.133,3.971 ZM13.133,10.508 C14.717,10.508 16.025,9.208 16.025,7.591 C16.025,5.974 14.717,4.674 13.133,4.674 C11.549,4.674 10.241,5.974 10.241,7.591 C10.241,9.208 11.549,10.508 13.133,10.508 ZM19.675,9.067 L18.539,9.208 C18.401,9.243 18.298,9.313 18.263,9.454 C18.194,9.665 18.126,9.805 18.057,9.946 C17.988,10.051 18.022,10.192 18.091,10.297 L18.298,10.613 C18.401,10.789 18.367,11.000 18.229,11.105 C18.160,11.176 18.091,11.211 18.022,11.211 C17.919,11.211 17.816,11.176 17.747,11.070 L17.506,10.754 C17.265,10.438 17.230,10.016 17.403,9.665 C17.471,9.524 17.540,9.383 17.575,9.208 C17.712,8.821 18.022,8.575 18.435,8.505 L19.537,8.329 C19.709,8.294 19.847,8.153 19.847,7.978 L19.847,7.205 C19.847,7.029 19.709,6.888 19.537,6.853 L18.435,6.677 C18.057,6.607 17.712,6.361 17.575,5.974 C17.540,5.834 17.471,5.693 17.403,5.553 C17.230,5.166 17.265,4.744 17.506,4.428 L18.194,3.479 C18.298,3.339 18.298,3.128 18.160,3.022 L17.609,2.495 C17.471,2.355 17.265,2.355 17.127,2.460 L16.232,3.128 C15.922,3.374 15.474,3.409 15.130,3.233 C14.992,3.163 14.855,3.093 14.717,3.057 C14.338,2.917 14.063,2.601 14.028,2.214 L13.856,1.089 C13.822,0.914 13.684,0.773 13.512,0.773 L12.755,0.773 C12.582,0.773 12.410,0.914 12.410,1.089 L12.238,2.214 C12.204,2.601 11.928,2.952 11.549,3.093 C11.412,3.163 11.274,3.198 11.136,3.268 C10.758,3.444 10.345,3.409 10.035,3.163 L9.139,2.495 C9.002,2.390 8.795,2.390 8.657,2.530 L8.141,3.057 C8.003,3.198 8.003,3.374 8.107,3.514 L8.795,4.463 C9.036,4.780 9.071,5.201 8.898,5.588 C8.830,5.728 8.795,5.869 8.726,6.045 C8.589,6.431 8.279,6.677 7.866,6.748 L6.764,6.923 C6.592,6.958 6.454,7.099 6.454,7.275 L6.454,8.048 C6.454,8.224 6.592,8.364 6.764,8.399 L7.866,8.575 C8.244,8.645 8.589,8.891 8.726,9.278 C8.795,9.454 8.830,9.594 8.898,9.700 C9.002,9.911 9.036,10.156 9.002,10.367 C8.967,10.578 8.795,10.684 8.589,10.649 C8.382,10.613 8.279,10.438 8.313,10.227 C8.313,10.156 8.313,10.086 8.279,10.016 C8.210,9.840 8.141,9.665 8.072,9.524 C8.038,9.383 7.900,9.313 7.797,9.278 L6.695,9.102 C6.179,9.032 5.800,8.575 5.800,8.013 L5.800,7.240 C5.800,6.713 6.179,6.256 6.695,6.150 L7.797,5.974 C7.934,5.939 8.038,5.869 8.072,5.728 C8.141,5.553 8.210,5.377 8.279,5.236 C8.348,5.131 8.313,4.990 8.244,4.885 L7.556,3.971 C7.246,3.549 7.280,2.952 7.659,2.565 L8.210,2.003 C8.520,1.546 9.105,1.511 9.518,1.863 L10.413,2.530 C10.517,2.601 10.654,2.636 10.792,2.565 C10.930,2.495 11.102,2.425 11.274,2.355 C11.412,2.319 11.481,2.214 11.515,2.074 L11.687,0.914 C11.756,0.387 12.204,-0.000 12.755,-0.000 L13.512,-0.000 C14.028,-0.000 14.476,0.387 14.579,0.914 L14.751,2.038 C14.786,2.179 14.855,2.284 14.992,2.319 C15.165,2.390 15.337,2.460 15.474,2.530 C15.578,2.601 15.750,2.565 15.853,2.495 L16.748,1.827 C17.162,1.511 17.781,1.546 18.160,1.933 L18.711,2.495 C19.090,2.882 19.124,3.479 18.814,3.901 L18.126,4.850 C18.057,4.955 18.022,5.096 18.091,5.201 C18.160,5.377 18.229,5.553 18.298,5.693 C18.332,5.834 18.435,5.904 18.573,5.939 L19.675,6.115 C20.191,6.185 20.570,6.642 20.570,7.205 L20.570,7.978 C20.570,8.505 20.191,8.962 19.675,9.067 ZM8.898,19.575 C8.898,19.891 8.761,20.208 8.554,20.454 L7.108,21.895 C7.039,21.965 6.970,22.000 6.867,22.000 C6.764,22.000 6.695,21.965 6.626,21.895 L1.083,16.307 C1.014,16.236 0.980,16.166 0.980,16.061 C0.980,15.955 1.014,15.885 1.083,15.815 L2.529,14.374 C2.976,13.917 3.768,13.917 4.216,14.374 L8.554,18.732 C8.795,18.943 8.898,19.259 8.898,19.575 ZM8.072,19.224 L3.699,14.866 C3.527,14.690 3.183,14.690 3.011,14.866 L1.840,16.061 L6.867,21.121 L8.072,19.927 C8.175,19.821 8.210,19.716 8.210,19.575 C8.210,19.435 8.175,19.329 8.072,19.224 Z"
                        />
                      </svg>

                      <p className="ps-1 profile-tab">Services</p>
                    </Nav.Link>
                  </Nav.Item>
                }
                <Nav.Item>
                  <Nav.Link eventKey="Certificate" className="d-flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="22px"
                    >
                      <path
                        fillRule="evenodd"
                        fill="rgb(11, 68, 113)"
                        d="M16.598,16.502 L16.598,21.154 C16.598,21.530 16.295,21.836 15.920,21.836 C15.679,21.836 15.796,21.869 13.547,20.575 L11.510,21.746 C11.057,22.007 10.495,21.676 10.495,21.154 L10.495,18.765 L1.457,18.765 C0.645,18.765 -0.015,18.100 -0.015,17.282 L-0.015,1.475 C-0.015,0.658 0.645,-0.007 1.457,-0.007 L13.430,-0.007 C14.242,-0.007 14.903,0.658 14.903,1.475 L14.903,9.082 L14.903,9.082 C18.056,10.111 19.012,14.168 16.598,16.502 ZM11.851,19.978 L13.210,19.196 C13.418,19.076 13.674,19.076 13.883,19.196 L15.242,19.978 L15.242,17.400 C14.159,17.855 12.932,17.855 11.851,17.400 L11.851,19.978 ZM13.546,1.475 C13.546,1.411 13.494,1.358 13.430,1.358 L1.457,1.358 C1.393,1.358 1.341,1.411 1.341,1.475 L1.341,17.283 C1.341,17.347 1.393,17.400 1.457,17.400 L1.457,17.400 L10.495,17.400 L10.495,16.503 C9.659,15.695 9.139,14.560 9.139,13.304 C9.139,10.857 11.116,8.867 13.546,8.867 L13.546,1.475 ZM13.547,10.232 C11.864,10.232 10.495,11.610 10.495,13.304 C10.495,14.998 11.864,16.376 13.547,16.376 C15.229,16.376 16.598,14.998 16.598,13.304 C16.598,11.610 15.229,10.232 13.547,10.232 ZM13.772,14.749 C13.641,14.946 13.426,15.053 13.207,15.053 L13.207,15.053 C12.942,15.053 12.908,14.990 11.814,14.256 C11.503,14.047 11.418,13.623 11.626,13.309 C11.834,12.996 12.255,12.911 12.566,13.120 L13.019,13.424 L13.999,11.944 C14.207,11.630 14.628,11.545 14.940,11.754 C15.251,11.963 15.336,12.387 15.128,12.701 L13.772,14.749 ZM9.817,7.502 L4.053,7.502 C3.679,7.502 3.375,7.196 3.375,6.819 C3.375,6.442 3.679,6.136 4.053,6.136 L9.817,6.136 C10.192,6.136 10.495,6.442 10.495,6.819 C10.495,7.196 10.192,7.502 9.817,7.502 ZM9.817,4.772 L4.053,4.772 C3.679,4.772 3.375,4.466 3.375,4.089 C3.375,3.712 3.679,3.406 4.053,3.406 L9.817,3.406 C10.192,3.406 10.495,3.712 10.495,4.089 C10.495,4.466 10.192,4.772 9.817,4.772 ZM4.053,8.867 L7.444,8.867 C7.818,8.867 8.122,9.172 8.122,9.550 C8.122,9.927 7.818,10.232 7.444,10.232 L4.053,10.232 C3.678,10.232 3.375,9.927 3.375,9.550 C3.375,9.172 3.678,8.867 4.053,8.867 Z"
                      />
                    </svg>

                    <p className="ps-1 profile-tab">Certificate</p>
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Other Info" className="d-flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22px"
                      height="22px"
                    >
                      <path
                        fillRule="evenodd"
                        fill="rgb(11, 68, 113)"
                        d="M18.390,-0.000 L3.610,-0.000 C2.653,-0.000 1.734,0.380 1.057,1.058 C0.380,1.735 -0.000,2.653 -0.000,3.611 L-0.000,18.389 C-0.000,19.347 0.380,20.266 1.057,20.942 C1.735,21.620 2.653,22.000 3.610,22.000 L18.390,22.000 C19.348,22.000 20.266,21.620 20.943,20.942 C21.619,20.265 22.000,19.347 22.000,18.389 L22.000,3.611 C22.000,2.653 21.620,1.734 20.943,1.058 C20.266,0.380 19.348,-0.000 18.390,-0.000 ZM20.002,18.390 C20.002,18.817 19.831,19.227 19.529,19.529 C19.227,19.831 18.817,20.001 18.390,20.002 L3.610,20.002 C3.183,20.001 2.774,19.831 2.472,19.529 C2.170,19.226 2.001,18.816 2.001,18.389 L2.001,3.611 C2.001,3.184 2.171,2.774 2.473,2.472 C2.774,2.170 3.184,1.1000 3.611,1.998 L18.390,1.998 C18.817,1.1000 19.227,2.170 19.529,2.472 C19.831,2.774 20.001,3.184 20.002,3.611 L20.002,18.389 L20.002,18.390 ZM9.126,10.616 L10.039,10.616 L10.039,15.875 L12.042,15.875 L12.042,9.299 L9.126,9.299 L9.126,10.616 ZM10.322,6.311 C10.504,6.190 10.718,6.125 10.937,6.125 C11.083,6.125 11.226,6.154 11.360,6.210 C11.494,6.265 11.616,6.347 11.719,6.449 C11.821,6.552 11.903,6.674 11.958,6.809 C12.013,6.943 12.042,7.087 12.041,7.232 C12.041,7.451 11.977,7.665 11.855,7.847 C11.733,8.029 11.561,8.171 11.358,8.254 C11.156,8.338 10.933,8.360 10.718,8.317 C10.503,8.274 10.306,8.168 10.152,8.014 C9.997,7.859 9.892,7.661 9.850,7.446 C9.807,7.232 9.829,7.009 9.914,6.807 C9.998,6.605 10.140,6.432 10.322,6.311 L10.322,6.311 Z"
                      />
                    </svg>

                    <p className="ps-1 profile-tab">Other Info</p>
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>

                  <Nav.Link eventKey="Rferral" className="d-flex">
                    <svg
                      viewBox="0 0 512 512"
                      width="18px"
                      height="22px"
                      xmlns="http://www.w3.org/2000/svg"
                      id="fi_1389008"
                    >
                      <path
                        fill="rgb(11, 68, 113)"
                        d="m250.902344 271.894531c1.691406.0625 3.386718.105469 5.097656.105469 1.585938 0 3.164062-.035156 4.738281-.09375 35.8125.773438 71.035157 10.25 102.15625 27.570312 9.652344 5.371094 21.832031 1.902344 27.203125-7.75 5.371094-9.652343 1.902344-21.832031-7.75-27.203124-14.328125-7.972657-29.386718-14.542969-44.933594-19.652344 33.117188-24.828125 54.585938-64.390625 54.585938-108.871094 0-74.992188-61.011719-136-136-136-74.992188 0-136 61.007812-136 136 0 44.507812 21.492188 84.09375 54.644531 108.917969-30.371093 9.996093-58.871093 25.546875-83.816406 46.0625-45.730469 37.617187-77.527344 90.085937-89.53125 147.742187-3.761719 18.066406.746094 36.621094 12.363281 50.910156 11.558594 14.214844 28.703125 22.367188 47.03125 22.367188h156.308594c11.042969 0 20-8.953125 20-20s-8.957031-20-20-20h-156.308594c-8.539062 0-13.6875-4.765625-16-7.605469-3.988281-4.90625-5.53125-11.289062-4.234375-17.519531 20.769531-99.761719 108.808594-172.617188 210.445313-174.980469zm-90.902344-135.894531c0-52.933594 43.0625-96 96-96 52.933594 0 96 43.066406 96 96 0 51.339844-40.507812 93.390625-91.238281 95.882812-1.589844-.03125-3.175781-.050781-4.761719-.050781-1.5625 0-3.121094.023438-4.679688.050781-50.769531-2.445312-91.320312-44.515624-91.320312-95.882812zm352 235.828125c.019531 13.359375-5.203125 25.914063-14.699219 35.359375l-37.199219 36.992188c-3.902343 3.882812-9.003906 5.820312-14.101562 5.820312-5.136719 0-10.273438-1.96875-14.183594-5.898438-7.789062-7.832031-7.753906-20.492187.078125-28.28125l24.933594-24.796874h-113.339844c-22.328125 0-40.488281 18.164062-40.488281 40.488281s17.941406 40.488281 40 40.488281c11.042969 0 20 8.953125 20 20s-8.957031 20-20 20c-21.511719 0-41.667969-8.398438-56.75-23.652344-14.996094-15.164062-23.25-35.347656-23.25-56.835937 0-44.382813 36.105469-80.488281 80.488281-80.488281h111.503907l-23.058594-22.800782c-7.851563-7.769531-7.925782-20.433594-.15625-28.285156 7.765625-7.851562 20.429687-7.925781 28.285156-.15625l37.140625 36.726562c9.523437 9.417969 14.777344 21.960938 14.796875 35.320313zm0 0"
                      ></path>
                    </svg>

                    <p className="ps-1 profile-tab">
                      {/* Referral <b>/</b> Reference */}
                      Reference Info
                    </p>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>

                  {/* <Nav.Link eventKey="promotion_media" className={isPreKYCUser ? "d-flex disable-media" : "d-flex"} disabled={isPreKYCUser}> */}
                  <Nav.Link eventKey="promotion_media" className={"d-flex"}>
                    <svg version="1.1" id="Layer_1" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 22 22" fill={"rgb(11, 68, 113)"}>
                      <g id="g2869" transform="translate(0.00925556)">
                        <path id="path1597" d="M17.9,8.45c0,0.33,0,0.67,0,1c1.22,0,2.43,0,3.65,0c0-0.33,0-0.67,0-1C20.33,8.45,19.12,8.45,17.9,8.45z" />
                        <path id="path1601" d="M18.33,10.79c-0.15,0.3-0.3,0.6-0.45,0.89c1.09,0.55,2.17,1.1,3.25,1.65c0.15-0.3,0.3-0.6,0.45-0.89
                            C20.49,11.89,19.41,11.33,18.33,10.79z"/>
                        <path id="path1605" d="M21.12,4.58c-1.09,0.55-2.17,1.1-3.25,1.65c0.15,0.3,0.3,0.6,0.45,0.89c1.08-0.55,2.17-1.1,3.25-1.65
                            C21.43,5.17,21.28,4.88,21.12,4.58z"/>
                        <path id="path1609" d="M12.75,4.11C9.79,5.07,6.83,6.03,3.87,6.99C3.81,6.98,3.76,6.95,3.71,6.95H1.51c-0.6,0-1.11,0.5-1.11,1.11
                            v3.92c0,0.6,0.5,1.11,1.11,1.11h0.35l2.39,6.7h3.53l-2.13-6.36c2.37,0.49,4.73,0.98,7.1,1.47v0.02c0,1.06,0.9,1.91,1.99,1.91
                            s1.99-0.85,1.99-1.91V4.13c0-1.06-0.9-1.92-1.99-1.92S12.77,3.06,12.75,4.11z M14.75,3.22c0.58,0,0.99,0.41,0.99,0.92v10.79
                            c0,0.5-0.42,0.91-0.99,0.91c-0.58,0-0.99-0.41-0.99-0.91V4.13C13.75,3.63,14.17,3.22,14.75,3.22z M12.75,5.16v8.71
                            c-2.64-0.55-5.29-1.1-7.93-1.64v-4.5C7.47,6.87,10.11,6.02,12.75,5.16z M1.51,7.95h2.19c0.07,0,0.11,0.04,0.11,0.11v1.46H1.4V8.06
                            C1.4,7.99,1.44,7.95,1.51,7.95z M1.4,10.52h2.41v1.46c0,0.07-0.04,0.11-0.11,0.11H1.51c-0.07,0-0.11-0.04-0.11-0.11V10.52z
                             M3.87,13.05c0.22,0.05,0.44,0.09,0.65,0.13l1.88,5.6H4.96l-2.04-5.7h0.78C3.76,13.09,3.81,13.06,3.87,13.05z"/>
                      </g>
                    </svg>

                    <p className="ps-1 profile-tab">
                      Promotion Media
                    </p>
                  </Nav.Link>

                </Nav.Item>

                {
                  (isSuperAdmin || isViewer) && <Nav.Item>
                    <Nav.Link className={"d-flex"} onClick={() => handleManageContactModal(id, company_contactDetail)}>
                      <i className="fa fa-address-book icon-address-book"></i>
                    </Nav.Link>
                  </Nav.Item>
                }

              </Nav>

              <div className={(isSuperAdmin || isOpUser) ? 'company-approve-btn custom-style' : 'hendle-aprove-btn'} >
                <div>

                  {
                    (isSuperAdmin || isOpUser) && includes([3], parseInt(companyStatus)) && (
                      <>
                        <ButtonAdminpanel
                          type="button"
                          className="mx-2 custom-padding"
                          onClick={() => handleCompanyStatusClick(2)}
                          title="Set InProgress"
                        >
                          <i className="fa fa-undo px-1" aria-hidden="true"></i>
                        </ButtonAdminpanel>
                      </>
                    )
                  }

                  {(isSuperAdmin || isOpUser) && includes([3, 4, 10], parseInt(companyStatus)) && (
                    <>
                      <ButtonAdminpanel
                        type="button"
                        className="mx-2 approve-color custom-padding"
                        // onClick={() => handleCompanyStatusClick(1)}
                        onClick={() => handleAssignPlan()}
                      >
                        <i className="fa fa-check px-1" aria-hidden="true"></i>Approve
                      </ButtonAdminpanel>
                    </>
                  )}

                  {/* {isSuperAdmin && !includes([0, 2, 4, -1], parseInt(companyStatus)) && ( */}
                  {(isSuperAdmin || isOpUser) && ![0, 2, 4, -1].includes(parseInt(companyStatus)) && parseInt(companyStatus) !== 10 && (
                    <ButtonAdminpanel
                      type="button"
                      className=" mx-2 reject-color custom-padding"
                      // onClick={() => handleCompanyStatusClick(4, 'this is reason')}
                      onClick={() => openReasonModal()}
                    >

                      <svg id="fi_2822680" fill="#ffffff" className="mx-1 pb-1" enable-background="new 0 0 512 512" height="18" viewBox="0 0 512 512" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m506.607 104.396-99.996-100.002c-2.813-2.814-6.629-4.394-10.607-4.394h-230.004c-24.813 0-45 20.187-45 45v197.838c-67.406 7.486-120 64.793-120 134.162 0 74.439 60.561 135 135 135h330c24.813 0 45-20.187 45-45v-351.997c0-3.979-1.58-7.793-4.393-10.607zm-95.607-53.183 32.59 32.591 16.196 16.196h-48.786zm-380 325.787c0-57.897 47.103-105 105-105s105 47.103 105 105-47.103 105-105 105-105-47.103-105-105zm435 105h-245.251c26.963-21.805 45.389-53.759 49.414-90h155.837c8.284 0 15-6.716 15-15s-6.716-15-15-15h-155.838c-2.446-22.02-10.204-42.459-21.968-60h177.806c8.284 0 15-6.716 15-15s-6.716-15-15-15h-205.251c-19.521-15.786-43.511-26.248-69.749-29.162v-197.838c0-8.271 6.729-15 15-15h215v85c0 8.284 6.716 15 15 15h85v337c0 8.271-6.729 15-15 15z"></path><path d="m426 182h-220c-8.284 0-15 6.716-15 15s6.716 15 15 15h220c8.284 0 15-6.716 15-15s-6.716-15-15-15z"></path><path d="m170.394 432.606c2.928 2.929 6.767 4.394 10.606 4.394s7.678-1.465 10.606-4.394c5.858-5.857 5.858-15.355 0-21.213l-34.393-34.393 34.394-34.394c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-34.394 34.394-34.394-34.394c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.355 0 21.213l34.394 34.394-34.394 34.394c-5.858 5.857-5.858 15.355 0 21.213 2.929 2.928 6.768 4.393 10.607 4.393s7.678-1.465 10.606-4.394l34.394-34.393z"></path></svg>
                      Reject
                    </ButtonAdminpanel>
                  )}

                  {/* {isSuperAdmin  && !includes([0, 2, 10, -1], parseInt(companyStatus) && parseInt(companyStatus) !== 4) && ( */}
                  {(isSuperAdmin || isOpUser) && ![0, 2, 10, -1].includes(parseInt(companyStatus)) && parseInt(companyStatus) !== 4 && (
                    <ButtonAdminpanel
                      type="button"
                      className="mx-2 suspend-color custom-padding"
                      onClick={() => handleSuspendClick()}
                    >
                      {/* <i className="fa fa-times px-1" aria-hidden="true"></i> */}
                      <svg id="fi_2808063" fill="#ffffff" enable-background="new 0 0 24 24" height="19" className="pb-1" viewBox="0 0 24 24" width="19" xmlns="http://www.w3.org/2000/svg"><path d="m8 0c-3.033 0-5.5 2.467-5.5 5.5v2.75c0 .965.785 1.75 1.75 1.75h3.75c-1.937 0-3.5-1.563-3.5-3.5 2.333 0 3.5-1.75 3.5-3.5 0 1.75 1.167 3.5 3.5 3.5 0 1.937-1.563 3.5-3.5 3.5h3.75c.965 0 1.75-.785 1.75-1.75v-2.75c0-3.033-2.467-5.5-5.5-5.5z"></path><path d="m11.706 12h-7.956c-2.068 0-3.75 1.682-3.75 3.75v3.5c0 .414.336.75.75.75h9.156c-.938-2.839-.216-5.877 1.8-8z"></path><path d="m17.5 11c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zm0 1.5c1.108 0 2.123.374 2.953.987l-6.967 6.966c-.612-.83-.986-1.845-.986-2.953 0-2.757 2.243-5 5-5zm0 10c-1.108 0-2.123-.374-2.953-.987l6.967-6.966c.612.83.986 1.845.986 2.953 0 2.757-2.243 5-5 5z"></path></svg>
                      Suspend
                    </ButtonAdminpanel>
                  )}

                  {((isEndUser || isPreKYCUser) && includes([2, 4], parseInt(companyStatus))) && (
                    <ButtonAdminpanel
                      type="button "
                      className="mx-2"
                      //onClick={()=>{handleApprovle()}}
                      // onClick={() => handleCompanyStatusClick(3)}
                      onClick={() => handleConsentModal()}
                    >
                      Send For Approval
                    </ButtonAdminpanel>
                  )}
                  {((isEndUser || isPreKYCUser) && (memberCompanyID == id)) && trade_mode_type !== "LOG_PTR" && (
                    <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: memberCompanyID })}`}>
                      <button type="button" className=" btn btn-light border preview-profile-btn btn" >
                        Preview your profile
                      </button>

                    </Link>
                  )}
                  {((isEndUser || isPreKYCUser) && (memberCompanyID == id)) && trade_mode_type === "LOG_PTR" && (
                    <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_LOGISTIC_PROFILE, { id: memberCompanyID })}`}>
                      <button type="button" className=" btn btn-light border preview-profile-btn btn" >
                        Preview your profile
                      </button>

                    </Link>
                  )}

                </div>

              </div>

            </div>



          </Col>

          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey="Compney Info">
                <CompanyInfo reasonVisible={(parseInt(companyStatus) === 4)} reason={props.company_info.reason} isDisable={isDisable} disableProfile={disableProfile} company_status={companyStatus} />
              </Tab.Pane>

              <Tab.Pane eventKey="Contact Info">
                <ContectInfo disableProfile={disableProfile} />
              </Tab.Pane>
              
              {
                cpInfo && cpInfo.trade_mode_type == "LOG_PTR" &&
                  <Tab.Pane eventKey="Services">
                    <MemberServices disableProfile={disableProfile} tradeModeType={cpInfo && cpInfo.trade_mode_type} cpInfo={cpInfo}/>
                  </Tab.Pane>
              }

              <Tab.Pane eventKey="Certificate">
                {
                  cpInfo && cpInfo.trade_mode_type !== "LOG_PTR" && <Certificate isDisable={isDisable} disableProfile={disableProfile} shipmentMode={cpInfo.trade_mode_type} />
                }

                {
                  cpInfo && cpInfo.trade_mode_type === "LOG_PTR" && <LogisticPartnerCertificate isDisable={isDisable} disableProfile={disableProfile} shipmentMode={cpInfo.trade_mode_type} />
                }


              </Tab.Pane>

              <Tab.Pane eventKey="Rferral">

                <RefrralSection disableProfile={disableProfile} />
              </Tab.Pane>

              <Tab.Pane eventKey="Other Info">
                <OtherDetails disableProfile={disableProfile} />
              </Tab.Pane>

              <Tab.Pane eventKey="promotion_media">
                <PromotionMediaInfo disableProfile={disableProfile} />
              </Tab.Pane>
            </Tab.Content>
          </Col>

        </Row>

      </Tab.Container>
      {/* {!isPreKYCUser && company_plan !== null && company_plan !== 'Trial' &&
        <ToastContainer />
      } */}

      {/** Reason popup */}
      <MediumPopup
        title="Please provide the reason"
        mediummodalShow={reasonModalShow}
        setMediumModalShow={setReasonModalShow}
        onSubmit={handleAddReasonClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Add"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">
            <TextAreaField name="reason" value={reason} onChange={handleReasonChange} maxLength={500 + 1} onBlur={handleFocusOut} />
            {errors.reason_max_char && (
              <p
                className="invalid-feedback"
                style={{ display: "block" }}
              >
                {errors.reason_max_char}
              </p>
            )}
          </div>
        </div>

      </MediumPopup>

      {/* send for aproval popup */}
      <MediumPopup
        title="Consent & Declaration"
        mediummodalShow={consentModal}
        setMediumModalShow={setConsentModal}
        onSubmit={() => handleCompanyStatusClick(3, '', isConsentChecked)}
        //closeButtonLabel="Cancel"
        okButtonLabel="I Agree"
        disabled={!consentBtnEnabled}

      >
        <div className='row approve-content-wrap'>

          <div className="col-md-12 px-0">

            <div className="contant" ref={scrollRef} onScroll={handleScroll}>

              <p className="content-heading">By completing your company profile and submitting your registration on <strong>Orex Trade World INC</strong>, you acknowledge and agree to the following terms:</p>

              <h2>1. Information Usage & Public Display</h2>
              <p>You authorize <strong>Orex Trade World INC</strong> to use the submitted business information, including:</p>
              <ul>
                <li>Company details</li>
                <li>Company certificates</li>
                <li>Company services</li>
                <li>Logo, product photos, videos</li>
                <li>Social media links</li>
                <li>Business descriptions and representative details</li>
              </ul>
              <p>These details may be <strong>publicly displayed</strong> on the Orex platform and across our official marketing, promotional and networking channels to enhance global visibility and connect you with verified buyers, suppliers and logistics partners.</p>

              <h2>2. Confidentiality of Business Certificates</h2>
              <p>We respect your privacy. Any <strong>business certificates, licenses or sensitive documents</strong> you upload for verification purposes will <strong>not be publicly displayed</strong> or shared with other users.</p>

              <p>These files are stored securely and used <strong>only for internal review and verification</strong> by the Orex Trade World team.</p>

              <h2>3. Content Ownership</h2>
              <p>You confirm that you have the legal right to submit all shared content (e.g., certificates, logo, media, business data) and grant Orex Trade World INC a <strong>non-exclusive right</strong> to use approved content for trade promotion and platform operations.</p>

              <h2>4. Accuracy & Authenticity of Information</h2>
              <p>All submitted data must be <strong>accurate and truthful.</strong>
              </p>
              <p>Providing <strong> false, misleading or fraudulent information</strong> is strictly prohibited. If such data is detected, immediate action will be taken.</p>

              <h2>5. Verification & Anti-Fraud Measures</h2>
              <p>Orex Trade World INC conducts <strong>manual and system-based verification.</strong> If any information is found to <strong>be fake, altered or used with intent to defraud,</strong> the company reserves the right to:</p>
              <ul>
                <li>Reject or cancel profile approval</li>
                <li>Suspend or permanently block the user</li>
                <li>Take legal or corrective action if necessary</li>
              </ul>

              <h2>6. Credits for Profile Views</h2>
              <p>By using the Platform, you acknowledge and agree that <b>20 credits </b> are awarded <b>per day </b> for <b>unique profile views</b> to support engagement and visibility on the Platform.</p>

              <h2>7. Platform Moderation Rights</h2>
              <p>Orex Trade World INC may edit, remove or flag any content that does not comply with platform policies or may negatively affect trade credibility or user experience.</p>

              <h2>8. User Responsibility & Limitation of Liability</h2>
              <p>You are solely responsible for the accuracy and legality of all submitted data. Orex Trade World INC will not be held liable for disputes, damages or claims resulting from inaccurate or unauthorized information submitted by the user.</p>

              <h2>9. Data Privacy & Confidentiality</h2>
              <p>Sensitive data such as your certificates, legal documents and ID proofs will be kept <strong>strictly confidential</strong> and are <strong>never displayed</strong> on your public profile. Only essential business information is shown for visibility and networking.</p>

              <h2>10. Agreement to Platform Terms</h2>
              <p>By submitting your profile, you confirm your agreement to <strong>Orex Trade World INC’s Terms of Use and Privacy Policy.</strong></p>

            </div>

          </div>

          {cpInfo && (
            <div className="col-xl-12 px-0">

              <div className="check-box d-flex align-items-center">
                <CheckBox
                  disabled={!isCheckedEnabled}
                  //  checked={}
                  // disabled={!checkboxEnabled} 
                  // ref={checkboxRef}
                  onChange={handleConsentClick}
                // className={(checkboxEnabled) ? "d-block":"d-none"}
                ></CheckBox>
                {/* <p className="mx-2"> I agree to the <a href= {cpInfo.trade_mode_type === "LOG_PTR" ? "https://orextrade.com/terms-and-conditions-logistic" : "https://orextrade.com/terms-and-conditions-buyer-supplier"} 
              target="_blank">Terms of Use</a> and <a href="https://orextrade.com/privacy-policy" target="_blank">Privacy Policy</a></p> */}
                <p className="mx-2"> I agree to the <a href={cpInfo.trade_mode_type === "LOG_PTR" ? `${publicRoutePaths.LOGISTIC_TERMS.path}` : `${publicRoutePaths.BUYER_SUPPLIER_TERMS.path}`} target="_blank">Terms of Use</a> and <a href={`${publicRoutePaths.PRIVACY_POLICY.path}`} target="_blank">Privacy Policy</a></p>
              </div>

            </div>
          )}

        </div>

      </MediumPopup>



      <SmallPopup
        title="Suspend Company"
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        onSubmit={() => handleCompanyStatusClick(10)}
        closeButtonLabel="No"
        okButtonLabel="Yes"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to suspend the company?</div>
        </div>
      </SmallPopup>

      <MediumPopup
        title="Assign Plan"
        mediummodalShow={planmodalShow}
        setMediumModalShow={setPlanModalShow}
        onSubmit={AssignPlanAndApprove}
        // closeButtonLabel="Skip"
        okButtonLabel="Assign"
        className="btn-assign"
        disabled={isButtonDisabled}
      >
        <form onSubmit={AssignPlanAndApprove}>

          <div className='row my-3'>

            <div className="col-xl-6 mt-2">
              <label className='popup-input-lable'>Established Year</label>
              <InputField
                className='w-100'
                // readOnly 
                value={assignPlanData.establish_date}
                disabled="true"
              />
              {errors.establish_year && (
                <p
                  className="invalid-feedback"
                  style={{ display: "block" }}
                >
                  {errors.establish_year}
                </p>
              )}
            </div>

            <div className="col-md-6 mt-2">
              <label className='popup-input-lable field-required'>Plan</label>
              <DropDown
                options={planList}
                placehoder="Select Plan"
                onChange={handlePlanChange}
                // onInputChange={handlePlanInputChange}
                name="plan_id"
                value={selectedPlan}
              ></DropDown>
            </div>

            {selectedPlan?.value !== undefined && selectedPlan?.value !== "" && (
              <>

                <div className="col-xl-6 mt-2">
                  <label className='popup-input-lable field-required'>From Date</label>
                  <DatePickerField
                    format="yyyy-MM-dd"
                    className='w-100'
                    // defaultValue={new Date()}
                    value={datePlan0}
                    // onChange={(value) => {
                    //   setDatePlan0(value);
                    //   handleBlur0(value);
                    // }}
                    onChange={(value) => {
                      setDatePlan0(value);
                      if (datePlan && value && value >= datePlan) {
                        setDatePlan(null);
                      }
                      handleBlur0(value);
                    }}
                    onBlur={() => handleBlur0(datePlan0)}
                    onOpenChange={(open) => {
                      if (!open) handleBlur0(datePlan0);
                    }}
                    disabledDate={(current) => {
                      return datePlan && current >= datePlan;
                    }}
                  />


                  {errors0.datePlan0 && (
                    <p
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors0.datePlan0}
                    </p>
                  )}
                </div>

                <div className="col-xl-6 mt-2">
                  <label className='popup-input-lable field-required'>To Date</label>

                  <DatePickerField
                    format="yyyy-MM-dd"
                    className="w-100"
                    value={datePlan}
                    // onChange={(value) => {
                    //   setDatePlan(value);
                    //   handleBlur(value);
                    // }}
                    onChange={(value) => {
                      setDatePlan(value);
                      if (datePlan0 && value && value <= datePlan0) {
                        setDatePlan0(null);
                      }
                      handleBlur(value);
                    }}
                    onBlur={() => handleBlur(datePlan)}
                    onOpenChange={(open) => {
                      if (!open) handleBlur(datePlan);
                    }}
                    disabledDate={(current) => {
                      return datePlan0 && current <= datePlan0;
                    }}
                  // disabledDate={disabledDate}
                  />

                  {errors0.datePlan && (
                    <p
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors0.datePlan}
                    </p>
                  )}
                </div>


                <div className="col-xl-12 mt-3">
                  <label className='popup-input-lable field-required'>Badge</label>

                  <div className='d-flex'>
                    <div className='mt-2'>
                      <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Basic")} name="badgeType" checked={badgePlan === "Basic"} />
                      <label className=''>BASIC</label>
                    </div>
                    <div className='mt-2'>
                      <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Plus")} name="badgeType" checked={badgePlan === "Plus"} />
                      <label className=''>PLUS</label>
                    </div>

                    <div className='mt-2'>
                      <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Pro")} name="badgeType" checked={badgePlan === "Pro"} />
                      <label className=''>PRO</label>
                    </div>
                    <div className='mt-2'>
                      <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Elite")} name="badgeType" checked={badgePlan === "Elite"} />
                      <label className=''>ELITE</label>
                    </div>

                  </div>

                  {errors0.badgePlan && (
                    <p
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors0.badgePlan}
                    </p>
                  )}
                </div>
              </>
            )}

          </div>
        </form>
      </MediumPopup>


      { /** Manage Contacts Modal */}
      <MediumPopup
        mediummodalShow={manageContactModalShow}
        setMediumModalShow={setManageContactModalShow}
        type="submit"
        onSubmit={AddContacts}
        okButtonLabel="Add"
        closeButtonLabel="Cancel"
        title="Manage Contacts"
      >
        <CKEditor
          key={`member_${selectedMemberId}`}
          editor={ClassicEditor}
          data={contactDetail || ''}
          config={{
            toolbar: {
              items: ['bold', 'italic', 'underline', 'fontSize', 'bulletedList', 'outdent', 'indent'],
            },
            fontSize: {
              options: [10, 12, 14, 'default', 18, 20, 22, 24, 30],
              supportAllValues: false,
            },
            language: 'en',
            plugins: [
              Essentials,
              Bold,
              Italic,
              Underline,
              FontSize,
              Paragraph,
              List,
              Indent
            ],
            licenseKey: "GPL",
            // licenseKey: "",

          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            setContactDetail(data);
          }}
          onReady={(editor) => {
            editor.editing.view.change((writer) => {
              writer.setStyle(
                "height",
                "150px",
                editor.editing.view.document.getRoot()
              );
              writer.setStyle(
                "width",
                "100",
                editor.editing.view.document.getRoot()
              );
            });
          }}
          onBlur={(event, editor) => {
            const data2 = editor.getData();
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = data2;

            const trimmedText = tempDiv.textContent.trim();

            if (isEmpty(trimmedText)) {
              setErrorContactDetail(errorMessages.FIELD_REQUIRED);
            } else {
              setErrorContactDetail("");
            }
          }}
        />
        {errorContactDetail &&
          <div className="company-required-content" style={styleError}>
            {" "}
            {errorContactDetail}
          </div>
        }


      </MediumPopup>
    </div >
  );
}

const mapStateToProps = (state) => {
  return {
    company_info: state.update.updateProfile,
    member_certificates: state.certificates.certificatelist,
    getOtherDetail: state.update.getOtherDetail
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    viewCompany: (member_id) => dispatch(viewProfileAction(member_id)),
    updateCompanyStatus: (companyID, status, reason, is_concerned) =>
      dispatch(updateCompanyStatus(companyID, status, reason, is_concerned)),
    getUpdatedProfile: () => dispatch(getUpdatedProfile()),
    getSubscriptionPlans: (offset, limit, columnName, sortDirection, type, searchTxt) =>
      dispatch(getSubscriptionPlanList(offset, limit, columnName, sortDirection, type, searchTxt)),
    assignPlanToMember: (data) => dispatch(assignPlanToMember(data)),
    getMemberTradeMode: (companyID) => dispatch(getMemberTradeMode(companyID)),
    getOtherDetailAction: (companyID) => dispatch(getOtherDetailAction(companyID)),
    getMemberProfileAction: (companyID) => dispatch(getMemberProfileAction(companyID)),
    manageContacts: (data, member_id) => dispatch(manageContacts(data, member_id))

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Updateprofile);
